export default class OrderTotalCalculator {
    constructor(modalSelector, mainController, uiManager) {
        this.modalSelector = modalSelector;
        this.mainController = mainController;
        this.uiManager = uiManager;
    }

    initializeDiscountHandling() {
        jQuery('input[name="payment_method"]').on('change', (e) => {
            this.uiManager.showTotalLoader();
            this.updateOrderTotal(jQuery(e.currentTarget).val());
        });
    }

    initializeQuantityHandling() {
        const updateAll = () => {
            const paymentMethod = jQuery('input[name="payment_method"]:checked').val() || '';
            if (paymentMethod) {
                this.uiManager.showTotalLoader();
                this.updateOrderTotal(paymentMethod);
                setTimeout(() => {
                    if (paymentMethod === 'vindi-pagamentos-credit') {
                        this.mainController.updateInstallmentsForSelectedPayment();
                    }
                }, 300);
            }
        };

        jQuery('.quantity-decrease').on('click', () => {
            const quantityInput = jQuery('#vindi-one-click-quantity');
            const currentValue = parseInt(quantityInput.val());
            if (currentValue > 1) {
                quantityInput.val(currentValue - 1);
                updateAll();
            }
        });

        jQuery('.quantity-increase').on('click', () => {
            const quantityInput = jQuery('#vindi-one-click-quantity');
            const currentValue = parseInt(quantityInput.val());
            const maxValue = parseInt(quantityInput.attr('max'));
            if (currentValue < maxValue) {
                quantityInput.val(currentValue + 1);
                updateAll();
            }
        });

        jQuery('#vindi-one-click-quantity').on('change', updateAll);
    }

    updateOrderTotal(paymentMethod) {
        const productInfo = this.mainController.getProductInfo();
        const appliedCoupons = this.mainController.getAppliedCoupons();

        this.uiManager.showTotalLoader();

        jQuery.ajax({
            url: vindiOneClick.ajax_url,
            type: 'POST',
            data: {
                action: 'calculate_one_click_discount',
                nonce: vindiOneClick.nonce,
                product_id: productInfo.productId,
                payment_method: paymentMethod,
                quantity: productInfo.quantity,
                coupon_codes: appliedCoupons
            },
            success: (response) => {
                if (response.success) {
                    this.updateOrderTotals(response.data);
                }
            },
            complete: () => {
                this.uiManager.hideTotalLoader();
            }
        });
    }

    updateOrderTotals(data) {

        jQuery('.payment-discount-row').hide();
        jQuery('.payment-discount-value').html('');
        jQuery('.coupon-discount-row').hide();
        jQuery('.coupon-discount-value').html('');
        jQuery('.total-discount-row').hide();
        jQuery('.total-discount-value').html('');

        jQuery('.subtotal-value').html(data.subtotal);
        jQuery('.total-value').html(data.total);
        if (data.total_raw !== undefined && parseFloat(data.total_raw) <= 0) {
            this.uiManager.showCouponMessage(data.messages.coupon_exceeds_total, 'error');
            jQuery('#vindi-process-quick-buy').prop('disabled', true);
        } else {
            jQuery('#vindi-process-quick-buy').prop('disabled', false);
        }

        if (data.payment_discount && parseFloat(data.payment_discount) > 0) {
            jQuery('.payment-discount-row').show();
            jQuery('.payment-discount-value').html(data.payment_discount_formated);
        }

        const appliedCoupons = this.mainController.getAppliedCoupons();
        const hasCoupons = appliedCoupons && appliedCoupons.length > 0;
        if (hasCoupons && data.coupon_discount && parseFloat(data.coupon_discount) > 0) {
            jQuery('.coupon-discount-row').show();
            jQuery('.coupon-label').html(`Cupom de Desconto:`);
            jQuery('.coupon-discount-value').html(data.coupon_discount_formated);
        }

        if (data.has_discount && data.discount && parseFloat(data.has_discount) > 0) {
            jQuery('.total-discount-row').show();
            jQuery('.total-discount-value').html(data.discount);
        }

        const newTotal = data.total;
        const oldTotal = jQuery('.total-value').data('previous-value') || '';
        jQuery('.total-value').data('previous-value', newTotal);

        const totalChanged = oldTotal !== newTotal;

        if (totalChanged || data.update_installments) {
            const paymentMethod = jQuery('input[name="payment_method"]:checked').val() || '';
            if (paymentMethod === 'vindi-pagamentos-credit') {
                setTimeout(() => this.mainController.updateInstallmentsForSelectedPayment(), 300);
            }
        }

        this.uiManager.hideTotalLoader();
    }
}